<template>
  <FormKit
    type="form"
    :value="{
        address_postal_code:'',
        address_thoroughfare:'',
        address_neighborhood: '',
        address_number: '',
        address_complement: '',
        address_state: '',
        address_locality: ''
    }"
    submit-label="Continuar"
    @submit="confirmData"
  >
    <h2 class="text-xl font-bold mb-1">Endereço</h2>

    <FormKit
      type="text"
      name="address_postal_code"
      id="address_postal_code"
      v-model="address_postal_code"
      @change="onInputCEP"
      label="Insira CEP ou Código postal da sua residência*"
      validation="required|length:8"
      :validation-messages="{
        required: 'Seu CEP é obrigatório',
        length: 'Quantidade de caracteres inválida'
      }"
    />
    <FormKit
      type="text"
      id="address_thoroughfare"
      v-model="address_thoroughfare"
      name="address_thoroughfare"
      label="Rua*"
      validation="required"
      :validation-messages="{
        required: 'O nome de sua rua é obrigatório'
      }"
    />
    <FormKit
      type="text"
      name="address_neighborhood"
      v-model="address_neighborhood"
      id="address_neighborhood"
      label="Bairro*"
      validation="required"
      :validation-messages="{
        required: 'O nome de seu bairro é obrigatório'
      }"
    />
    <div class="address">
      <div class="address__address_number">
        <FormKit
          type="text"
          name="address_number"
          label="Número"
        />
      </div>

      <div class="address__address_complement">
        <FormKit
          type="text"
          name="address_complement"
          label="Complemento"
        />
      </div>
    </div>

    <FormKit
      type="select"
      name="address_state"
      id="estado"
      label="Estado*"
      placeholder="-- Selecione um estado"
      v-model="estadoSelecionado"
      validation="required"
      :validation-messages="{
          required: 'Seu estado é obrigatório'
        }"
    >
      <template v-for="states in listStates">
        <option :value="states.value" :id="states.id">{{ states.label }}</option>
      </template>
    </FormKit>

    <FormKit
      type="text"
      name="address_locality"
      v-model="address_locality"
      id="address_locality"
      label="Cidade*"
      validation="required"
      :validation-messages="{
        required: 'O nome de sua cidade é obrigatório'
      }"
    />

    <template #submit>
      <FooterButton/>
    </template>

  </FormKit>
</template>

<script>
  import FooterButton from '../../components/FooterButton.vue';
  import HeaderTitle from '@/cadastro/components/HeaderTitle.vue';
  import { useStore } from '@/stores/cadastro';
  import { useRouter } from 'vue-router'
  import { getAddressFromPostalCodeAndNumber } from '../../address';
  import { ref } from 'vue';
  import Swal from 'sweetalert2';

  export default {
    props: {
      address: Object,
    },
    components: {
      FooterButton,
      HeaderTitle
    },
    data() {
      return {
        addressToEdit: {...this.address},
        addressPostalCodeNotFound: false,
        address_postal_code: '',
        address_thoroughfare: '',
        address_neighborhood: '',
        address_stateSelecionado: '',
        address_locality: '',
      }
    },
    setup () {
      const store = useStore();
      const router = useRouter();
      const listStates = ref([
          { label: 'Acre', value: 'AC' },
          { label: 'Alagoas', value: 'AL' },
          { label: 'Amapá', value: 'AP' },
          { label: 'Amazonas', value: 'AM' },
          { label: 'Bahia', value: 'BA' },
          { label: 'Ceará', value: 'CE' },
          { label: 'Distrito Federal', value: 'DF' },
          { label: 'Espírito Santo', value: 'ES' },
          { label: 'Goiás', value: 'GO' },
          { label: 'Maranhão', value: 'MA' },
          { label: 'Mato Grosso', value: 'MT' },
          { label: 'Mato Grosso do Sul', value: 'MS' },
          { label: 'Minas Gerais', value: 'MG' },
          { label: 'Pará', value: 'PA' },
          { label: 'Paraíba', value: 'PB' },
          { label: 'Paraná', value: 'PR' },
          { label: 'Pernambuco', value: 'PE' },
          { label: 'Piauí', value: 'PI' },
          { label: 'Rio de Janeiro', value: 'RJ' },
          { label: 'Rio Grande do Norte', value: 'RN' },
          { label: 'Rio Grande do Sul', value: 'RS' },
          { label: 'Rondônia', value: 'RO' },
          { label: 'Roraima', value: 'RR' },
          { label: 'Santa Catarina', value: 'SC' },
          { label: 'São Paulo', value: 'SP' },
          { label: 'Sergipe', value: 'SE' },
          { label: 'Tocantins', value: 'TO' }
        ]);

        const confirmData = async (formData) => {
          await store.updatePersonalData(formData);
          router.push({ name: 'UploadProof' })
        }

        return {
          listStates,
          confirmData
        };
    },
    methods: {
      onInputCEP() {
        const postalCode =  document.getElementById("address_postal_code");
        postalCode.readOnly = false;
        const quickTest = /^\s*([0-9-, ]+)$/;
        if (quickTest.test(postalCode.value)) {

          const fullTest = /^\s*([0-9]{5}-?[0-9]{3})(,\s*|\s+)?(\d+)?/;
          const match = fullTest.exec(postalCode.value);
          if (match === null) {
            return;
          }
          postalCode.value = postalCode.value.replace('-', '');

          this.queryInput({inputText: postalCode.value});
        }
      },

      async queryAddressFromPostalCode({inputText, requireGeolocation = false} = {}) {

        try {
          Swal.fire({
            title: 'Buscando endereço',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          })
          this.addressToEdit = await getAddressFromPostalCodeAndNumber(inputText, "", {requireGeolocation});
        }
        catch (error) {
          this.addressPostalCodeNotFound = true;
        } finally {
          Swal.close();
        }
      },

      queryInput: function ({inputText}) {
        this.queryAddressFromPostalCode({ inputText, requireGeolocation: false }).then(() => {
          this.updateFieldsAddress(this.addressToEdit);
        });
      },

      updateFieldsAddress (addressToEdit) {
        this.address_thoroughfare = addressToEdit.thoroughfare;
        this.address_locality = addressToEdit.city;
        this.address_neighborhood = addressToEdit.neighborhood;
        this.estadoSelecionado = addressToEdit.state;
      },
    }
  }
</script>
